'use client';
import React, { memo } from 'react';
import Image from 'next/image';
import Link from 'next/link';

import { IButton, ITypo } from '@/app/_components/common';
import { LocationIcon, TimerIcon } from '@/app/assets/Icons';
import { Images } from '@/app/assets/images';
import { ROUTERS } from '@/constants';
import { formatDayMonthYear, getImageUrl, insertObjectIf } from '@/utils';
import { cn } from '@nextui-org/react';

interface IProps {
	item: any;
	isMainArticle?: boolean;
	className?: string;
	dataAos?: string;
}

const ArticleCard: React.FC<IProps> = ({
	item,
	isMainArticle,
	className,
	dataAos,
}) => {
	return (
		<div
			className={cn(
				'col lg:row border-silver rounded-3xl border bg-white max-lg:p-3 lg:gap-4 lg:border-none',
				className,
				{
					'lg:col lg:border-pink-yellow hidden lg:flex lg:border-2 lg:border-dashed lg:p-5':
						isMainArticle,
				}
			)}
			data-aos={dataAos}
		>
			<div
				className={cn(
					'relative min-h-full w-full flex-1 overflow-hidden rounded-xl lg:min-h-[360px]',
					{
						'aspect-auto max-lg:aspect-video lg:min-h-[198px] lg:max-w-[314px]':
							!isMainArticle,
					}
				)}
			>
				<Image
					src={
						getImageUrl(item?.banner, Images.home.courseBanner)
							.imageUrl
					}
					blurDataURL={
						getImageUrl(item?.banner, Images.home.courseBanner)
							.imagePlaceholder
					}
					placeholder="blur"
					alt={item?.name || 'DLA Da Nang'}
					className="object-cover object-center"
					fill
				/>
			</div>

			<div className="lg:flex-1">
				<div className="col mb-4 mt-3 gap-2">
					<ITypo
						size={16}
						weight="semi"
						className="lg:text-20 line-clamp-1"
					>
						{item?.title}
					</ITypo>

					{!isMainArticle && (
						<IButton className="h-fit min-h-[30px] w-fit lg:h-8 lg:min-h-8">
							<ITypo size={14} className="lg:text-16 font-medium">
								Tin Tức
							</ITypo>
						</IButton>
					)}

					<ITypo size={14} className="lg:text-16 line-clamp-3">
						{item?.description}
					</ITypo>

					{isMainArticle && (
						<>
							<div className="row text-blue-ocean gap-1">
								<TimerIcon />
								<ITypo
									size={14}
									weight="semi"
									className="line-clamp-1"
								>
									{item?.startTime} - {item?.endTime},{' '}
									{formatDayMonthYear(item?.startTime)}
								</ITypo>
							</div>
							{item?.location && (
								<div className="row text-blue-ocean gap-1">
									<LocationIcon />
									<ITypo
										size={14}
										weight="semi"
										className="line-clamp-1"
									>
										{item?.location}
									</ITypo>
								</div>
							)}
						</>
					)}
				</div>

				<div className="row text-gray justify-between gap-3">
					<ITypo size={14} className="">
						{formatDayMonthYear(item?.createdAt)}
					</ITypo>

					<Link
						{...insertObjectIf(
							isMainArticle,
							{
								href: ROUTERS.EVENT_DETAIL.replace(
									':slug',
									item?.slug
								),
							},
							{
								href: ROUTERS.NEW_DETAIL.replace(
									':slug',
									item?.slug
								),
							}
						)}
					>
						<IButton
							className="text-bittersweet lg:border-bittersweet h-fit min-h-5 w-fit py-0 lg:min-h-10 lg:border lg:border-solid"
							variant="transparent"
						>
							<ITypo size={14} className="lg:text-16 font-medium">
								Xem thêm
							</ITypo>
						</IButton>
					</Link>
				</div>
			</div>
		</div>
	);
};

export default memo(ArticleCard);
